{/* eslint-disable i18next/no-literal-string */}
const HeadingStyles = {
  baseStyle: {
    color: "textGray",
    textTransform: "uppercase",
  },
};

export default HeadingStyles;
